import IssueTopicList from "./IssueTopicList";
import IssueTopicEdit from "./IssueTopicEdit";
import IssueTopicCreate from "./IssueTopicCreate";

export default {
    list: IssueTopicList,
    edit: IssueTopicEdit,
    create: IssueTopicCreate,
};
